export default from './AffordabilityCalculator';



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/index.js